// components/ThemeManager.jsx - VERSIÓN SIMPLIFICADA
import React, { createContext, useState, useEffect, useContext } from 'react';
import { ThemeContext } from '../App';

export const ThemeManagerContext = createContext();

export const ThemeManagerProvider = ({ children }) => {
  const { theme: customColors = {} } = useContext(ThemeContext);
  const [themeMode, setThemeMode] = useState(localStorage.getItem('theme') || 'light');
  
  // Colores por defecto para cada modo
  const lightColors = {
    primary: customColors.primary ,
    secondary: customColors.secondary ,
    mode: 'light'
  };
  
  const darkColors = {
    primary: '#0d6efd', 
    secondary: '#e0e0e0', 
    mode: 'dark'
  };
  
  // Seleccionar colores basados en el modo
  const themeColors = themeMode === 'dark' ? darkColors : lightColors;

  const toggleThemeMode = () => {
    const newMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newMode);
    localStorage.setItem('theme', newMode);
    
    // Aplicar clase al body
    document.body.setAttribute('data-theme', newMode);
  };

  useEffect(() => {
    // Inicializar
    document.body.setAttribute('data-theme', themeMode);
  }, [themeMode]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--primary-color', themeColors.primary);
    root.style.setProperty('--secondary-color', themeColors.secondary);
  }, [themeColors]);

  const value = {
    themeMode,
    themeColors,
    toggleThemeMode
  };

  return (
    <ThemeManagerContext.Provider value={value}>
      {children}
    </ThemeManagerContext.Provider>
  );
};

export const useThemeManager = () => {
  const context = useContext(ThemeManagerContext);
  if (!context) {
    throw new Error('useThemeManager debe usarse dentro de ThemeManagerProvider');
  }
  return context;
};